import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/feature/JsonLd';
import { organizationSchema, getWebSiteSchema, getWebPageSchema } from '@/mocks/schemas';
import HeroBanner from './components/HeroBanner';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import TrendingSection from './components/TrendingSection';
import LatestSection from './components/LatestSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <JsonLd schema={organizationSchema} />
      <JsonLd schema={getWebSiteSchema()} />
      <JsonLd schema={getWebPageSchema(
        '韩漫在线阅读-好看的韩漫推荐-免费韩国漫画大全-韩漫网',
        '韩漫网提供免费韩国漫画大全和好看韩漫推荐，支持在线阅读，您能轻松发现热门作品并沉浸其中，让每一次点击都带来惊喜与愉悦的阅读旅程。',
        'https://www.manhuakr.com'
      )} />
      <Navbar />
      <main>
        <HeroBanner />
        <CategorySection />
        <FeaturedSection />
        <TrendingSection />
        <LatestSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}